import React from 'react';
import './style.scss';
import { Spinner } from 'react-bootstrap';
import useClientCoffeeInvoice from './hooks';
import Forms from '../../../../../components/molecules/forms';
import OrganismsForms from '../../../../../components/organisms/forms';
import Cards from '../../../../../components/molecules/cards';

function ClientDetailCoffeeInvoices() {
  const {
    handleChangeEndDate, handleChangeStartDate, onChangeSearchValue, searchValue, selectedDate,
    invoicesLoading, paidInvoiceList,
  } = useClientCoffeeInvoice();
  if (invoicesLoading) {
    return (
      <div className="d-flex justify-content-center">
        <Spinner animation="border" />
      </div>
    );
  }
  return (
    <div>
      <div className="px-4 px-xl-5">
        <div className="row mb-4">
          <div className="col-xl-9 col-lg-8 mb-4" style={{ height: '42px' }}>
            <Forms.Search
              placeholder="Search"
              onChange={(e) => onChangeSearchValue(e.target.value)}
              value={searchValue}
            />
          </div>
          <div className="col-xl-3 col-lg-4" style={{ height: '42px' }}>
            <OrganismsForms.DateRangePicker
              id="dateRangePicker"
              handleChangeStart={handleChangeStartDate}
              handleChangeEnd={handleChangeEndDate}
              startDate={{ current: new Date(selectedDate.start) }}
              endDate={{ current: new Date(selectedDate.end), disabled: true }}
            />
          </div>
        </div>
        <div className="row">
          {paidInvoiceList.map((paid) => (
            <div key={paid.id} className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-2">
              <Cards.Pending
                badgeCard={(
                  <Cards.Badge
                    id={`${paid.id.toString()}cardBadge`}
                    label="-"
                    iconType="snack"
                    isCancel={false}
                  />
                )}
                title="Coffee Invoice"
                price={paid.paidAmount ?? paid.billAmount}
                date={new Date(new Date(paid.paidDate).setDate(new Date(paid.paidDate).getDate() - 1))}
                id={paid.id.toString()}
                pending={false}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ClientDetailCoffeeInvoices;
